export default {
  ADVANCED: 'ADVANCED',
  FIRST_GEN: 'FIRST_GEN',
  OTHER: 'OTHER',
  RFNBO_HYDROGEN: 'RFNBO_HYDROGEN',
  OTHER_RENEWABLE_HYDROGEN: 'OTHER_RENEWABLE_HYDROGEN',
};
